import * as R from 'ramda'
import fileDialog from 'file-dialog'
import G from '../util/globalFunction'
import { serverUrl, serverPrefixUrl } from '../config'
import fetchApi from '../util/fetchApi'
import axios from 'axios'
import React, { Fragment, useRef, useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload, faTimes } from '@fortawesome/free-solid-svg-icons'
import tremApi from './tremApi'
import progress from '../static/images/common/progress.png'
import { width } from 'dom-helpers'
import defaultImg from '../static/images/common/logo_g.jpg'

const makeUploadFormData = (object, ATTACH_SKEY = null, FILE_EXTENSION = null) => {
    const formData = new FormData()
    formData.append('file', object)

    if(typeof ATTACH_SKEY !== 'undefined' && ATTACH_SKEY !== null && ATTACH_SKEY !== '') {
        formData.append('ATTACH_SKEY', ATTACH_SKEY)
    }
    if(typeof FILE_EXTENSION !== 'undefined' && FILE_EXTENSION !== null && FILE_EXTENSION !== '') {
        formData.append('FILE_EXTENSION', FILE_EXTENSION)
    }

    return formData
}

const registerListener = (request, customProgress, resolve, reject) => {
    const returnError = (event, message) => reject({ event, message })
    const loadFnt = event => {
        G.loadingEnd()
        try {
            resolve(JSON.parse(event.currentTarget.response))
        } catch (err) {
            returnError(event, '파일전송결과에 오류가 있습니다.')
        }
    }
    const errFnt = event => returnError(event, '파일 전송 중 오류가 발생했습니다.')
    const abrtFnt = event => returnError(event, '파일 전송을 취소했습니다.')
    const defaultProgress = () => G.loadingStart()
    const progressFnt = ({ total, loaded }) => {
        const progress = parseInt((loaded / total) * 100, 10)
        customProgress ? customProgress(progress) : defaultProgress(progress)
    }
    request.addEventListener('load', loadFnt)
    request.addEventListener('error', errFnt)
    request.addEventListener('abort', abrtFnt)
    request.upload.addEventListener('progress', progressFnt, false)
}


/**
 * 파일 업로드
 * option 항목
 * blob: image blob
 * customProgress: 진행 상태 표시 callback 함수
 * ATTACH_SKEY : 포함하는 객체 식별자
 * @param {object} option
 */
export const uploadBlob = option =>
    new Promise((resolve, reject) => {
        const { blob, customProgress, ATTACH_SKEY } = option
        const uploadUrl = `${serverUrl}${serverPrefixUrl}/attach/upload`
        const getRequest = () => {
            const request = new XMLHttpRequest()
            registerListener(request, customProgress, resolve, reject)
            request.open('POST', uploadUrl)
            return request
        }
        const send = request => request.send(makeUploadFormData(blob, ATTACH_SKEY))

        R.pipe(
            getRequest,
            send
        )()
    })

/**
 * 파일 업로드
 * option 항목
 * fileSelected: 파일이 선택되었을 때, 표시용 callback 함수
 * customProgress: 진행 상태 표시 callback 함수
 * sourceId : 포함하는 객체 식별자
 * @param {object} option
 */
export const fileUpload = option =>
    new Promise((resolve, reject) => {
       
        fileDialog({ multiple: false }).then(files => {
            const setUploadingState = () => {
                if(!R.isNil(option[Object.keys(option)[0]].setUploadingFunc)) {
                    const setUploadingFlag = option[Object.keys(option)[0]].setUploadingFunc
                    setUploadingFlag(true)
                }
            }
            const { fileSelected, customProgress, ATTACH_SKEY, FILE_EXTENSION, imageUpload} = option[Object.keys(option)[0]] || {}
            // console.log("업로드 option:>>>>",imageUpload)
            const uploadUrl = imageUpload===true?`${serverUrl}${serverPrefixUrl}/attach/upload/images`:`${serverUrl}${serverPrefixUrl}/attach/upload`
            const getRequest = () => {
                const request = new XMLHttpRequest()
                registerListener(request, customProgress, resolve, reject)
                request.open('POST', uploadUrl)
                return request
            }
            const send = request => request.send(makeUploadFormData(files[0], ATTACH_SKEY, FILE_EXTENSION))
            const startFn = request => {
                const abort = () => request.abort()
                fileSelected && fileSelected({ file: fileData, abort })
            }

            R.pipe(
                setUploadingState,
                getRequest,
                send,
                startFn
            )()
            
        })
    })

/**
 * VModalMultiSelect 첨부파일 업로드
 * (VModalMultiSelect에서 +버튼 클릭하여 파일 업로드 후, ATTACH_SKEY 리턴함)
 * ATTACH_SKEY : 첨부키
 */
 export const uploadFile = ATTACH_SKEY => 
    fileUpload({ATTACH_SKEY})
    .then(obj => {
        return obj.data.ATTACH_SKEY
    })
    .catch(alert)

/**
 * !graphql사용시!
 * VModalMultiSelect 첨부파일 리스트 조회
 * (VModalMultiSelect.defaultValue 에 넣을 파일 리스트 조회. [{key, title}] 리턴함)
 * ATTACH_SKEY : 첨부키
 */
export const getFileList = ATTACH_SKEY => 
    fetchApi(`query {
        attachFileList(ATTACH_SKEY:${ATTACH_SKEY}) {
            ATTACH_SKEY, FILE_SKEY, REAL_NAME
        }
    }`).then(obj => {
        let defaultValue = []
        
        obj.attachFileList.map(file => {
            defaultValue.push(
                {"key":file.FILE_SKEY, "title":file.REAL_NAME}
            )
        })

        return defaultValue
    })

/**
 * 첨부파일 리스트 조회
 * ATTACH_SKEY : 첨부키
 */
export const selectFileList = (ATTACH_SKEY) => {
    return Promise.resolve(
        // 파일 리스트 불러오기 
        tremApi('/attach/retreive_file_list', {ATTACH_SKEY})
        .then((fileList) => {
            return fileList
        })
    )
}

/**
 * !graphql사용시!
 * VModalMultiSelect 첨부파일 삭제
 * (VModalMultiSelect에서 x 버튼 클릭 시 파일 삭제 성공시 ATTACH_SKEY 리턴하고, 실패시 "파일 삭제 실패" alert 띄움)
 * ATTACH_SKEY : 첨부키
 * FILE_SKEY : 파일키
 */
export const deleteFile = (ATTACH_SKEY, FILE_SKEY) => 
    fetchApi(`mutation {
        deleteAttachFile(ATTACH_SKEY:${ATTACH_SKEY}, FILE_SKEY:${FILE_SKEY})
    }`).then(
        (obj) => {
            const success = obj.deleteAttachFile.success
            success ? () => {return ATTACH_SKEY} : alert(G.t('trem.lang.home.1131'))  /* 파일 삭제 실패 */
        }
    )

/**
 * 첨부파일 삭제
 * FILE_SKEY : 첨부파일키
 */
 export const removeFile = (FILE_SKEY) => {
    return Promise.resolve(
        // 파일 삭제하기
        tremApi('/attach/delete', {FILE_SKEY})
        .then((removeFileResult) => {
            return removeFileResult
        })
    )
}

/**
 * 첨부파일 전체삭제
 * FILE_SKEY : 첨부파일키
 */
 export const allRemoveFile = (ATTACH_SKEY) => {
    return Promise.resolve(
        // 파일 전체삭제하기
        tremApi('/attach/delete/all', {ATTACH_SKEY})
        .then((removeFileResult) => {
            return removeFileResult
        })
    )
}

/**
 * VModalMultiSelect 첨부파일 다운로드
 * (VModalMultiSelect에서 파일명 클릭 시 파일 다운로드)
 * FILE_SKEY : 파일키
 * REAL_NAME : 파일명(확장자 포함)
 */
export const downloadFile = (FILE_SKEY, REAL_NAME) => {
    if(FILE_SKEY) {
        axios({
            method: 'POST',
            url: `${serverUrl}${serverPrefixUrl}/attach/download`,
            headers: {
                //
            },
            responseType: 'arraybuffer',
            params: {
                FILE_SKEY:FILE_SKEY
            }
        }).then(response => {
            const url = window.URL.createObjectURL(
                new Blob([response.data], { type: response.headers['content-type'] })
            )
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', `${REAL_NAME}`)
            document.body.appendChild(link)
            link.click()
            window.URL.revokeObjectURL(link); //메모리 누수 방지
        })
    } else {
        alert(G.t('trem.lang.home.1132'), G.t('trem.lang.home.1137')) /* 파일키가 없습니다. */
    }
}


/**
 * 첨부파일 전체다운로드
 * ATTACH_SKEY : 첨부키
 */
export const allDownloadFile = (ATTACH_SKEY) => {
    if(ATTACH_SKEY) {
        axios({
            method: 'POST',
            url: `${serverUrl}${serverPrefixUrl}/attach/download/all`,
            headers: {
                //
            },
            responseType: 'arraybuffer',
            params: {
                ATTACH_SKEY:ATTACH_SKEY
            }
        }).then(response => {
            const url = window.URL.createObjectURL(
                new Blob([response.data], { type: response.headers['content-type'] })
            )
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'file_'+Date.now())
            document.body.appendChild(link)
            link.click()
            window.URL.revokeObjectURL(link); //메모리 누수 방지
        })
    } else {
        alert(G.t('trem.lang.home.0820'), G.t('trem.lang.home.1137')) /* 다운로드할 첨부파일이 없습니다. */
    }
}


/**
 * 파일 업로더
 * (파일 조회 및 편집을 위함)
 * 
 * *** uploaded/deleted callback 사용 시 유의 ***
 * uploaded/deleted 작업이 완료되면, callback을 사용하는 경우에 한해 flag:true로 변경됨.
 * 파일 업로더를 호출한 곳에서 이를 확인 => flag가 true일 경우 callback을 실행,
 * callback 실행 시 ☆flag:false로 set☆한 후 callback 작업하도록 해야 함.
 * 
 * 
 * attachFileInfo : 파일업로더 사용 위한 저장소
 * - ATTACH_SKEY : 첨부키
 * - fileList : 첨부파일리스트
 * - readOnly : 편집(삭제, 업로드) 가능여부
 * - oneFileOnly : 파일 개수 (업로드 시 사용)
 * - imageView : 이미지로 조회 여부
 * - useUploadCallbackFlag : 업로드 콜백 사용여부
 * - uploadedFlag : 업로드 시 true로 일시적 변경 (* 콜백 사용 후 다시 false로 set해야함.)
 * - usedeletedCallbackFlag : 업로드 콜백 사용여부
 * - deletedFlag : 삭제 시 true로 일시적 변경 (* 콜백 사용 후 다시 false로 set해야함.)
 * 
 * setAttachFileInfo : 정보 set 위한 useState명
 */
export const FileUploader = ({attachFileInfo, setAttachFileInfo}) => {
    const { 
        ATTACH_SKEY, fileList, 
        readOnly, oneFileOnly, imageView, 
        useUploadCallbackFlag, uploadedFlag,
        usedeletedCallbackFlag, deletedFlag, fileUploadExtension,
        imageUpload=false 
    } = attachFileInfo

    // 파일리스트
    const setFileList = () => {
        selectFileList(ATTACH_SKEY).then((fileList) => {
            setAttachFileInfo({
                ...attachFileInfo,
                fileList
            })
        })  
    }

    // 마운트 시 실행
    useEffect(() => {
        if(!readOnly) {
            setAttachFileInfo({
                ...attachFileInfo,
                //oneFileOnly : false
            })
        }

        if(!R.isNil(ATTACH_SKEY) && ATTACH_SKEY != "") {
            setFileList()
        }
    }, [])

    // 마운트 후 ATTACH_SKEY 생성될 때 실행
    useEffect(() => {
        if(!R.isNil(ATTACH_SKEY) && ATTACH_SKEY != "") {
            setFileList()
        }
    }, [ATTACH_SKEY])

    // 조회대상 이미지키
    const [activeImgIndex, setActiveImgIndex] = useState(0)

    // 업로드 중 여부
    const [uploadingFlag, setUploadingFlag] = useState(false)

    const inputRef =useRef(null);

    return (
        <Fragment>
            {imageView
                ? //이미지
                <Fragment>
                    <div style={{width: '100%', height: '100%', border: '1px solid #ddd'}}>
                        {fileList.length != 0
                            ?
                            fileList.map((obj, index) => {
                                if(oneFileOnly && index == 0 || !oneFileOnly && index === activeImgIndex) {
                                    const downURL = serverUrl + serverPrefixUrl + '/attach/download?FILE_SKEY=' + obj?.FILE_SKEY
                                    return (
                                        <img
                                            key={index}
                                            alt={obj?.REAL_NAME} 
                                            src={downURL} 
                                            style={{width: '100%', height: '100%', objectFit:'contain', objectPosition: 'center'}}
                                        />
                                    )
                                }
                            })
                            : <img 
                                alt="no image" 
                                src={defaultImg} 
                                style={{width: '100%', height: '100%', objectFit:'contain', objectPosition: 'center'}}
                            />
                        }
                    </div>
                    {!oneFileOnly
                        &&
                        <Fragment>
                            <div className="equip_img_btn">
                                <a  
                                    href='javascript:void(0);'
                                    title ="이전"
                                    className="prev"
                                    onClick = {() => fileList.length != 0 && activeImgIndex != 0
                                        && 
                                        setActiveImgIndex(activeImgIndex-1)
                                    }
                                >
                                    {G.t('trem.lang.home.0345')}
                                    {/* 이전 */}
                                </a>
                                <span>{fileList.length != 0 ? activeImgIndex+1 : 0}/{fileList.length}</span>
                                <a  href='javascript:void(0);'
                                    title ="다음"
                                    className="next"
                                    onClick = {() => fileList.length != 0 && (activeImgIndex+1) < fileList.length
                                        && 
                                        setActiveImgIndex(activeImgIndex+1)
                                    }
                                >다음</a>
                            </div>
                        </Fragment>
                    }
                </Fragment>
                : //일반
                <Fragment>
                    <div className="file_attach_box">
                        <ul>
                            <li>
                                {/* 전체다운로드 */}
                                {!oneFileOnly 
                                &&<a 
                                     href='javascript:void(0);'
                                     //tabIndex="0" 
                                     title ="전체다운로드"
                                     className="btn_download"
                                     onClick={() => {
                                        if(ATTACH_SKEY && fileList.length != 0) {
                                            allDownloadFile(ATTACH_SKEY)
                                        } else {
                                            alert(G.t('trem.lang.home.0820'))
                                            /* 다운로드할 첨부파일이 없습니다. */
                                        }
                                    }}
                                >
                                    {G.t('trem.lang.home.0343')}
                                    {/* 전체다운로드 */}
                                </a>
                                }
                                {/* 전체삭제 */}
                                {!readOnly && !oneFileOnly
                                    && <a 
                                          href='javascript:void(0);'
                                          //tabIndex="0" 
                                          title ="전체삭제"  
                                          className="btn_delete"
                                          onClick={() => {
                                            if(!R.isNil(ATTACH_SKEY) && fileList.length != 0) {
                                                G.confirm(G.t('trem.lang.home.0813'/*첨부된 모든 파일을 삭제하시겠습니까?*/)).then((confirmValue) =>{
                                                    if(confirmValue){
                                                        allRemoveFile(ATTACH_SKEY)
                                                        .then((allRemoveFileResult) => {
                                                            if(allRemoveFileResult) {
                                                                setAttachFileInfo({
                                                                    ...attachFileInfo, 
                                                                    fileList : [],
                                                                    deletedFlag : usedeletedCallbackFlag ? true : false
                                                                })
                                                            } else {
                                                                alert(G.t('trem.lang.home.0901')) /* 파일 전체 삭제에 실패하였습니다. */
                                                            }
                                                        })
                                                    }
                                                })
                                            } else {
                                                let msg = R.isNil(ATTACH_SKEY) ? '첨부키가 없습니다' : G.t('trem.lang.home.0814')/* 삭제할 첨부파일이 없습니다. */
                                                alert(msg)
                                            }
                                        }}
                                    >{G.t('trem.lang.home.0344')}</a>
                                }
                                {/* 업로드 */}
                                {!readOnly
                                    && <a
                                        href='javascript:void(0);'
                                        //tabIndex="0" 
                                        title="업로드"
                                        className="btn1"
                                        ref={inputRef}
                                        onClick={() => {
                                            const fileUploadProps = {
                                                ATTACH_SKEY : oneFileOnly ? null : ATTACH_SKEY,
                                                FILE_EXTENSION : fileUploadExtension,
                                                setUploadingFunc : setUploadingFlag,
                                                imageUpload
                                            }
                                            fileUpload({fileUploadProps}).then((fileUploadResult) => {
                                                // remove all loading bar
                                                G.loadingForceEnd()
                                                if(fileUploadResult.success) {
                                                    setAttachFileInfo({
                                                        ...attachFileInfo,
                                                        ATTACH_SKEY : fileUploadResult.data.ATTACH_SKEY,
                                                        fileList : fileUploadResult.data.list ?? fileList,
                                                        uploadedFlag : useUploadCallbackFlag ? true : false
                                                    })
                                                    setUploadingFlag(false)
                                                    if(fileUploadResult?.data?.FAIL){
                                                        alert(G.t('trem.lang.home.0913')) /* 이미지 파일을 올려주세요. */
                                                    }else{
                                                        alert(G.t('trem.lang.home.0811')) /* 파일이 성공적으로 업로드 되었습니다. */
                                                        inputRef.current.focus()
                                                    }
                                                } else {
                                                    alert(fileUploadResult?.message)
                                                    // alert(G.t('trem.lang.home.0902')) /* 파일 업로드에 실패하였습니다. */
                                                    setUploadingFlag(false)
                                                }
                                            })
                                        }}
                                    >{G.t('trem.lang.home.0107')}</a>/* 업로드 */
                                }
                            </li>
                            <li>
                                <ul className="upload_file_list">
                                    {fileList.length != 0
                                        &&
                                        fileList.map((obj, index) => {
                                            return (
                                                <li key={index}>
                                                    {/* 파일다운로드 */}
                                                    <a  href='javascript:void(0);'
                                                        title = "파일다운로드"
                                                        className="file_download_link" 
                                                        onClick={() => downloadFile(obj?.FILE_SKEY, obj?.REAL_NAME)} 
                                                    ><FontAwesomeIcon icon={faDownload}/><em>{obj?.REAL_NAME}</em></a>

                                                    {/* 파일삭제 */}
                                                    {!readOnly
                                                        &&
                                                        <a  href='javascript:void(0);'
                                                            title= "파일삭제"
                                                            className="file_remove"
                                                            onClick={() => {
                                                                if(!R.isNil(obj?.FILE_SKEY)) {
                                                                    G.confirm(G.t('trem.lang.home.0812')) /*첨부된 파일을 삭제하시겠습니까?*/
                                                                    .then((confirmValue) => {
                                                                        if(confirmValue) {
                                                                            removeFile(obj?.FILE_SKEY)
                                                                            .then((removeFileResult) => {
                                                                                if(removeFileResult) {
                                                                                    setAttachFileInfo({
                                                                                        ...attachFileInfo, 
                                                                                        fileList : fileList.filter(fileList => fileList?.FILE_SKEY !== obj?.FILE_SKEY),
                                                                                        deletedFlag : usedeletedCallbackFlag ? true : false
                                                                                    })
                                                                                    inputRef.current.focus()
                                                                                } else {
                                                                                    alert(G.t('trem.lang.home.0903')) /* 파일 삭제에 실패하였습니다. */
                                                                                }
                                                                            })
                                                                        }
                                                                    })
                                                                } else {
                                                                    alert(G.t('trem.lang.home.1132'), G.t('trem.lang.home.1137')) /* 파일키가 없습니다. */
                                                                }
                                                            }}
                                                        ><FontAwesomeIcon icon={faTimes}/></a> 
                                                    }
                                                </li>
                                            )
                                        })
                                    }
                                </ul> 
                                {uploadingFlag
                                    && 
                                    <ul>
                                        <div className="mt-1.5" style={{backgroundImage: `url(${progress})`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover', width: '100%', height: '5px'}}></div>
                                    </ul>
                                }
                            </li>
                        </ul>
                    </div>
                </Fragment>
            }
        </Fragment>
    )
}